import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {fetchCipDepartmentsAction, 
        fetchCipGroupAction, 
        fetchCipMembersAction, 
        removeCipMemberAction, 
        addCipMemberAction, 
        saveCipGroupAction,
        fetchCipTransactionsAction,
        saveCipTransactionAction} from '../actions/';
import EditCipGroupPage from '../components/CipGroups/EditCipGroupPage';


class EditCipGroupContainer extends Component {
  render() {
    const { actions } = this.props;
    const { groupId } = this.props.params;
    const { cipDepartments } = this.props;
    var { currentCipGroup } = this.props;
    const { router } = this.props;

    if(groupId || groupId >= 0){

    }
    else{
        currentCipGroup = {
          Group : {
            Account : {},
            CipGroupDepartment : {},
            CipGroupManager : {}
          },
          Loading : false,
          Transactions : [],
          Members : []
        }
    }
    const { authInfo } = this.props;
    
    return <EditCipGroupPage authInfo={authInfo} router={router} currentCipGroup={currentCipGroup} cipDepartments={cipDepartments} actions={actions} groupId={groupId}/>;
   
  }

  componentDidMount() {
    const {actions} = this.props;
    const { groupId } = this.props.params;
    actions.fetchCipDepartmentsAction();
    if(groupId || groupId >= 0){
      actions.fetchCipGroupAction(groupId).then(() => {
        actions.fetchCipMembersAction(groupId);
        actions.fetchCipTransactionsAction(groupId);
      });
    }
  }
}

EditCipGroupContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {
    cipDepartments : state.cipDepartments,
    currentCipGroup : state.currentCipGroup,
    authInfo : state.authInfo
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    fetchCipDepartmentsAction, 
    fetchCipGroupAction, 
    fetchCipMembersAction, 
    removeCipMemberAction, 
    addCipMemberAction, 
    saveCipGroupAction,
    fetchCipTransactionsAction,
    saveCipTransactionAction
  };
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCipGroupContainer);



// WEBPACK FOOTER //
// ./containers/EditCipGroupContainer.js